import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import {MdBallot, MdBookmarkAdd, MdDownload, MdHome, MdLogout, MdArticle, MdDarkMode, MdList} from 'react-icons/md';
import { User } from '../../types/user';
import Cookies from 'js-cookie';
import isAdmin from 'src/utils/isAdmin';
import { Platform } from 'src/types/constants';

const Layout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const user: User = JSON.parse(Cookies.get('user') || '{}');
  // const platform: Platform = JSON.parse(Cookies.get('platform') || '{}');
  const platform: Platform = JSON.parse(localStorage.getItem('platform') || "{}")

  const openConfirmModal = () => {
    const qcDoneModal = document.querySelector('#qcDoneModal') as HTMLElement;
    qcDoneModal.click();
  };

  const handleLogout = () => {
    Cookies.remove('user');
    Cookies.remove('platform');
    navigate('/login');
  };

  const handleDarkMode = () => {
    const currentTheme = localStorage.getItem("theme");
    const newTheme = currentTheme === "dark" ? "light" : "dark";

    document.body.classList.toggle("dark-theme", newTheme === "dark");

    localStorage.setItem("theme", newTheme);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    document.body.classList.toggle("dark-theme", savedTheme === "dark");
  }, []);

  const showQCDoneButton = user.id && pathname.includes('/epics/');
  const eligibleAdminButtons = isAdmin(user.email ?? '');

  return (
    <>
      <div className="navbar bg-base-100 shadow-md">
        <div className="container mx-auto">
          <div className="flex justify-between items-center w-full">
            <div>
              <a
                href="/"
                className="btn btn-outline btn-sm"
              >
                <MdHome />
                <span className="text-xs mr-2">پروژه</span>
              </a>

            </div>

            <div>
              <button
                  className="btn btn-outline btn-sm"
                  onClick={handleDarkMode}
              >
                <MdDarkMode />
                <span className="text-xs mr-2">تغییر تم</span>
              </button>
            </div>

            <div>
              {showQCDoneButton && (
                <button
                  className="btn btn-outline btn-sm ml-2"
                  onClick={openConfirmModal}
                >
                  <MdBookmarkAdd />
                  <span className="text-xs mr-2">اتمام کار</span>
                </button>
              )}

              {eligibleAdminButtons && platform?.id && (
                  <>
                    <a
                        href="/epics-srolsnfoapfnkb"
                        className="btn btn-outline btn-sm mx-1"
                    >
                      <MdList/>
                      <span className="text-xs mr-2">لیست</span>
                    </a>
                    <a
                        href="/factory"
                        className="btn btn-outline btn-sm mx-1"
                    >
                      <MdDownload/>
                      <span className="text-xs mr-2">فکتوری</span>
                    </a>
                    <a
                        href="/activities"
                        className="btn btn-outline btn-sm mx-1"
                    >
                      <MdBallot/>
                      <span className="text-xs mr-2">فعالیت‌ها</span>
                    </a>
                    <a
                        href="/report"
                        className="btn btn-outline btn-sm"
                    >
                      <MdArticle/>
                      <span className="text-xs mr-2">گزارش</span>
                    </a>
                  </>
              )}
            </div>

            <div>
              {user.id && (
                  <button
                      className="btn btn-outline btn-sm"
                      onClick={handleLogout}
                  >
                    <MdLogout />
                  <span className="text-xs mr-2">خروج</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="p-2">
        <div className="container mx-auto">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Layout;
